import "@polymer/polymer/polymer-legacy.js";
import { html } from "@polymer/polymer/lib/utils/html-tag.js";
import "@polymer/paper-button/paper-button.js";
import "./success.js";
import "./shared-styles.js";
import { PolymerElement } from "@polymer/polymer/polymer-element.js";
class SubmittedForm extends PolymerElement {
    static get template() {
        return html `
            <style include="shared-styles">
                :host {
                    display: block;
                    padding: 10px;
                    height: calc(100vh - 20px);
                    background: -webkit-linear-gradient(
                        45deg,
                        #0077b5,
                        #008891
                    );
                }
                .container {
                    width: 400px;
                    display: block;
                    margin: 0 auto;
                }

                #return {
                    display: block;
                    margin: 0 auto;
                    width: 200px;
                    text-align: center;
                    background-color: #2672ae;
                    color: white;
                }
            </style>
            <div class="container">
                <div class="card">
                    <email-sent
                        api-base-url="{{apiBaseUrl}}"
                        data="[[data]]"
                    ></email-sent>
                    <paper-button id="return" on-click="returnPage"
                        >Return</paper-button
                    >
                </div>
            </div>
        `;
    }
    static get is() {
        return "submitted-form";
    }
    static get properties() {
        return {
            apiBaseUrl: {
                type: String,
                notify: true,
            },
            data: {
                type: Object,
                value: undefined,
                notify: true,
            },
        };
    }
    returnPage() {
        console.log("RETURNED");
        this.dispatchEvent(new CustomEvent("changeRoute", {
            bubbles: true,
            composed: true,
            detail: {
                route: ``,
            },
        }));
    }
}
window.customElements.define(SubmittedForm.is, SubmittedForm);
//# sourceMappingURL=submitted.js.map